<button
  class="secondary-button"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="toggleOpen()"
  [title]="panelTitle()">
  <img [src]="iconSrc()" alt="" />
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="close()"
  [cdkConnectedOverlayPositions]="positions">

  <div class="bl-panel">
    <div class="bl-panel-header">
      <label class="bl-select-all">
        <input
          #selectAllCheckbox
          type="checkbox"
          [checked]="isAllSelected()"
          (change)="toggleAll()"
        />
        {{ panelTitle() | translate }}
      </label>
      <button class="bl-close-btn" (click)="close()">&#x2715;</button>
    </div>
    <ul class="bl-list">
      @for (item of items(); track item.key) {
        <li>
          <label>
            <input
              type="checkbox"
              [checked]="isVisible(item.key)"
              (change)="toggle(item.key)"
            />
            {{ item.label | translate }}
          </label>
        </li>
      }
    </ul>
  </div>

</ng-template>
